import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bg-palette1 p-2 text-center text-white"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" please give us your feedback using "),
  /*#__PURE__*/_createElementVNode("a", {
    class: "underline",
    href: "https://forms.gle/KDQ5kNBJ8uCDYfdS9"
  }, "this form "),
  /*#__PURE__*/_createTextVNode("! ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { computed } from "vue"
import {isMobileScreen } from "@/screenSize"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


const isMobile = computed(()=> isMobileScreen())


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(isMobile))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true)
  ]))
}
}

})